"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitListItemCreateButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const dialogs_1 = require("../../../../../dialogs");
const validation_1 = require("../../../../../pages/mechanics/marketing/wait-list/item/form/validation");
const WaitListItemCreateButton = (props) => {
    const { className, waitListList: { id, contract, root }, disabled, variant, onRefreshPage, } = props;
    const { openDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const initialValues = {
        account: "",
        listId: id,
    };
    const handleCreate = () => {
        openDialog(dialogs_1.GlobalDialogKeys.WAITLIST_LIST_CREATE_BUTTON, initialValues, {
            initialValues,
            refetch: onRefreshPage,
            url: "/wait-list/item",
            validationSchema: validation_1.waitlistItemValidationSchema,
            message: "dialogs.create",
            testId: "WaitListFormDialog",
            filter: ({ account, listId }) => ({
                account,
                listId,
            }),
            prepareInitialValues: ({ id, listId, account }) => ({ id, listId, account }),
        });
    };
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleCreate, icon: icons_material_1.Add, message: "form.buttons.add", className: className, dataTestId: "WaitListListCreateButton", disabled: disabled || !!root || contract.contractStatus !== types_1.ContractStatus.ACTIVE, variant: variant }));
};
exports.WaitListItemCreateButton = WaitListItemCreateButton;
//# sourceMappingURL=index.js.map